import { useMemo } from 'react';
import { useTable } from 'react-table';
import { DocumentationListWrapper, TableWrapper } from './styles';

const tableHeaders = [
  {
    Header: 'Group',
    accessor: 'docGroup',
  },
  {
    Header: 'Document',
    accessor: 'document',
  },
  {
    Header: 'Title 1',
    accessor: 'title1',
  },
  {
    Header: 'Title 2',
    accessor: 'title2',
  },
  {
    Header: 'Title 3',
    accessor: 'title3',
  },
  {
    Header: 'Sta',
    accessor: 'status',
  },
  {
    Header: 'Rev',
    accessor: 'revision',
  },
];

const DocumentationList = ({ documents: tableData, isProject }) => {
  const columns = useMemo(() => tableHeaders, []);

  const Table = ({ columns, data }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
      columns,
      data,
    });

    return (isProject ?
            <ul>
              {tableData && tableData.map(doc => <li>{doc}</li>)}
            </ul>
          :
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <DocumentationListWrapper>
      {/* <HeaderText>
            {headerText}
        </HeaderText> TODO*/}
      <TableWrapper>
        <Table
          columns={columns}
          data={tableData}
        />
      </TableWrapper>
    </DocumentationListWrapper>
  );
};

export default DocumentationList;
